module.exports = __webpack_public_path__ + "static/e70526378c3489411a1a81fce4d51f76.svg";